import axios from "axios";

const B = process.env.REACT_APP_BACKEND_URL;
const auth = () => ({ headers: { Authorization: `Bearer ${localStorage.getItem("token")}` } });

// cols: [{ label, get: (row) => value, total: "sum" | "avg" | undefined, pct?: bool }]
export const totalsOf = (rows, cols) => cols.map((c) => {
  if (!c.total) return null;
  const vals = rows.map(c.get).filter((v) => typeof v === "number" && !Number.isNaN(v));
  if (!vals.length) return null;
  const sum = vals.reduce((a, b) => a + b, 0);
  return c.total === "avg" ? sum / vals.length : sum;
});

export const fmtTotal = (v, c) => (v == null ? "" : `${Math.round(v * 10) / 10}${c.pct ? "%" : ""}`);

// Excel export of exactly what's on screen (plus the totals row)
export const exportXlsx = async (title, cols, rows) => {
  const tot = totalsOf(rows, cols);
  const body = rows.map((r) => cols.map((c) => { const v = c.get(r); return v === undefined ? null : v; }));
  if (rows.length && cols.some((c) => c.total)) body.push(cols.map((c, i) => (i === 0 ? (c.total ? tot[0] : "Total") : tot[i] == null ? null : Math.round(tot[i] * 1000) / 1000)));
  const res = await axios.post(`${B}/api/verizon-sales/export`, { title, headers: cols.map((c) => c.label), rows: body }, { ...auth(), responseType: "blob" });
  const a = document.createElement("a");
  a.href = URL.createObjectURL(res.data);
  a.download = `${title.replace(/[^A-Za-z0-9_-]+/g, "-")}.xlsx`;
  a.click();
  URL.revokeObjectURL(a.href);
};

const iso = (d) => `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}-${String(d.getDate()).padStart(2, "0")}`;
export const PRESETS = {
  today: () => { const t = iso(new Date()); return [t, t]; },
  yesterday: () => { const d = new Date(); d.setDate(d.getDate() - 1); const t = iso(d); return [t, t]; },
  this_month: () => { const d = new Date(); return [iso(new Date(d.getFullYear(), d.getMonth(), 1)), iso(d)]; },
  last_month: () => { const d = new Date(); return [iso(new Date(d.getFullYear(), d.getMonth() - 1, 1)), iso(new Date(d.getFullYear(), d.getMonth(), 0))]; },
};
